<div>
    <span *ngIf="required">*</span>
    <span *ngIf="required" class="cdk-visually-hidden">This item is required.</span>
    <div class="mat-body-2">
        <ng-content class="mat-body-2"></ng-content>
    </div>
    <!-- <span class="mat-body-2" [innerHTML]="LabelText | safeHTML"></span> -->
</div>


// WEBPACK FOOTER //
// ./src/app/ui/formlabel/formlabel.component.html